// Native
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

// Imported
import { NgxPopperModule } from 'ngx-popper';

// Components
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { RestoreComponent } from './restore/restore.component';
import { PreloaderModule } from '../../resources/components/preloader/preloader.module';
import { LogoModule } from "../../resources/components/logo/logo.module";

// Modules
import { SharedModule } from '../../modules/shared.module';
import { ValidateModule } from "../../resources/modules/validate/validate.module";
import {AuthRoutesModule} from './auth-routes/auth-routes.module';



@NgModule({
  declarations: [
    LoginComponent,
    SignupComponent,
    RestoreComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ValidateModule,
    SharedModule,
    NgxPopperModule,
    RouterModule,
    PreloaderModule,
    LogoModule,
    AuthRoutesModule
  ]
})
export class AuthModule { }
